$(function() {
  var personFormTableLoader = function($contactLink) {
    var activeLink = null;
    var lock = false;
    $contactLink.on('ajax:success', function(event) {
      const data = event.detail[2].responseText;

      var currentRow = $contactLink.parents('tr');
      var columns = currentRow.find('td');
      var dataAttr = $contactLink.data();

      //remove all existing form rows and remove highlight color
      $('.contact-person__table-form-row').remove();
      $('tr.form-expanded').removeClass('form-expanded')

      // create a new one
      var newRow = '<tr class="contact-person__table-form-row"><td colspan="{0}">{1}</td></tr>'.f(columns.length, data)
      activeLink = dataAttr['index'];
      // insert the new row
      $(currentRow).after(newRow);
      $(currentRow).addClass('form-expanded');
      // get the form element of inserted content
      var form = $('.contact-person__table-form-row').find('form');

      selectize_all_selects();
      ContactFormHelper.registerContactFormHandler(function() {
        $('.contact-person__table-form-row').remove();
        $(currentRow).removeClass('form-expanded');
        $('input, textarea').placeholder();
      });
      lock = false;
    }).on('ajax:beforeSend', function() {
      // just hide the element if it's active
      if (activeLink === $contactLink.data()['index'] && !lock) {
        var formRow = $('.contact-person__table-form-row');

        formRow.find('form').animate({
            height: 'toggle'
          } , {
            duration: 400,
            specialEasing: {
              height: 'easeInOutExpo'
            },
            complete: function() {
              formRow.remove();
              $('tr.form-expanded').removeClass('form-expanded');
          }
        });

        activeLink = null;
        return false;
      } else {
        lock = true;
      }
    }).on('ajax:error', function(event) {
    });
  }

  var contactSwitchHandler = function(contactLink) {
    $contactLink = $(contactLink);
    var dataAttr = $contactLink.data('switch-contact');
    $contactLink.on('ajax:success', function(event) {
      const data = event.detail[2].responseText;
      // TODO Path won't be updated in older IE
      if (typeof window.history.pushState === 'function') {
        var path = contactLink[0].href;
        window.history.pushState('state', 'title', path);
      }

      $(dataAttr.container).replaceWith(data);

      // register contact-switch handler for ajax-loaded content
      contactSwitchHandler($(dataAttr.container).find('[data-behavior=switch-contact]'));

      // register person-form handler for ajax-loaded content
      $('[data-behavior=person-form-table-loader]').existsEach(function ($contactLink) {
        personFormTableLoader($contactLink);
      });

      picturefill();
      $(dataAttr.container).find('.gridder').gridderExpander({
        scroll: true,
        scrollOffset: 30,
        scrollTo: "listitem",                  // panel or listitem
        animationSpeed: 400,
        animationEasing: "swing",
        showNav: true,                      // Show Navigation
        nextText: "",                   // Next button text
        prevText: "",               // Previous button text
        closeText: "",                 // Close button text
        onContent: function() {
          ContactFormHelper.registerContactFormHandler();
          selectize_all_selects();
          $('input, textarea').placeholder();
        }
      });
    });
  };

  $('[data-behavior=switch-contact]').existsEach(function ($contactLink) {
    contactSwitchHandler($contactLink)
  });

  $('[data-behavior=person-form-table-loader]').existsEach(function ($contactLink) {
    personFormTableLoader($contactLink);
  });
});
